import {
  SET_CUSTOMER_FOR_NEW_ORDER,
  GET_ALL_CART_ITEMS_SUCCESS,
  GET_ALL_CART_ITEMS_REQUEST,
  RESET_CART_STATE,
  SET_CUSTOMER_FOR_NEW_ORDER_DATA,
  SET_NEW_COUPON,
  VIEW_CART_LITE_REQUEST,
  VIEW_CART_LITE_SUCCESS,
  TOGGLE_CART_FETCHING,
  VIEW_CART_FETCHING,
  SET_COMMISSION,
} from "./actionTypes";

export const actions = {
  resetCart: () => ({
    type: RESET_CART_STATE,
  }),
  setNewCustomerForOrder: (payload) => ({
    type: SET_CUSTOMER_FOR_NEW_ORDER,
    payload,
  }),
  toggleCartFetching: () => ({
    type: TOGGLE_CART_FETCHING,
  }),
  viewCartLiteFetching: () => ({
    type: VIEW_CART_FETCHING,
  }),
  getAllCartItems: (payload) => ({
    type: GET_ALL_CART_ITEMS_REQUEST,
    payload,
  }),
  setNewCustomerForOrderData: (payload) => ({
    type: SET_CUSTOMER_FOR_NEW_ORDER_DATA,
    payload,
  }),
  setNewCoupon: (payload) => ({
    type: SET_NEW_COUPON,
    payload,
  }),
  viewCartLiteRequest: (payload) => ({
    type: VIEW_CART_LITE_REQUEST,
    payload,
  }),
  viewCartLiteSuccess: (data, userId) => {
    const filterObj = data.result.reduce((acc, cur) => {
      if (cur.quantity) {
        if (acc[userId]) {
          acc[userId][`${cur.sku_id}`] = cur.quantity;
        } else {
          acc[`${userId}`] = { [`${cur.sku_id}`]: cur.quantity };
        }
      }
      return acc;
    }, {});
    return {
      type: VIEW_CART_LITE_SUCCESS,
      payload: {
        data: data.result,
        filterData: filterObj,
        cartDetails: data.cartTotal,
        fetching: false,
      },
    };
  },
  setCommission: (payload) => ({
    type: SET_COMMISSION,
    payload,
  }),
};

const initialState = {
  userIdForOrder: null,
  cartItems: [],
  filterData: [],
  cartDetails: {},
  userForOrder: {},
  currentCoupon: null,
  couponSucced: false,
  fetching: false,
  viewCartFetching: false,
  commission: 0,
};

// selectors
export function getAddedProductListIds(cart) {
  return (
    (cart.cartItems &&
      cart.cartItems.reduce((acc, car, index) => {
        if (index > 2) return acc;
        acc[`r${index + 1}`] = car.sku_id;
        return acc;
      }, {})) ||
    {}
  );
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CUSTOMER_FOR_NEW_ORDER: {
      return {
        ...state,
        userIdForOrder: action.payload,
      };
    }

    case SET_CUSTOMER_FOR_NEW_ORDER_DATA: {
      return {
        ...state,
        userForOrder: action.payload,
      };
    }

    case SET_NEW_COUPON: {
      const { payload } = action;

      return {
        ...state,
        currentCoupon: payload.currentCoupon,
        couponSucced: payload.couponSucced,
      };
    }

    case GET_ALL_CART_ITEMS_SUCCESS:
      return {
        ...state,
        cartItems: action.payload.data,
        filterData: action.payload.filterData,
        cartDetails: action.payload.cartDetails,
        fetching: false,
      };

    case VIEW_CART_LITE_SUCCESS: {
      return {
        ...state,
        cartItems: action.payload.data,
        filterData: action.payload.filterData,
        cartDetails: action.payload.cartDetails,
        viewCartFetching: false,
      };
    }

    case TOGGLE_CART_FETCHING: {
      return {
        ...state,
        fetching: !state.fetching,
      };
    }
    case VIEW_CART_FETCHING: {
      return {
        ...state,
        viewCartFetching: true,
      };
    }

    case RESET_CART_STATE: {
      return {
        ...state,
        userIdForOrder: null,
        cartItems: [],
        filterData: [],
        cartDetails: {},
        userForOrder: {},
        currentCoupon: null,
        couponSucced: false,
        fetching: false,
        viewCartFetching: false,
      };
    }
    case SET_COMMISSION: {
      return {
        ...state,
        commission: action.payload,
      };
    }
  }

  return state;
};
reducer.initialState = initialState;

export default reducer;
